import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { spacing } = tokens;

const BrandIconSupportTechnical = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 48 48'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <defs>
                <style>{'.SupportTechnical_svg__cls-1{fill:#002664}'}</style>
            </defs>
            <path
                className='SupportTechnical_svg__cls-1'
                d='M34.5 17a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm5 0a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5z'
            />
            <path d='M14 26a5 5 0 11-5-5 5 5 0 015 5z' fill='#d7153a' />
            <path
                className='SupportTechnical_svg__cls-1'
                d='M25.5 27.5A1.5 1.5 0 1127 26a1.5 1.5 0 01-1.5 1.5zM19 29a3 3 0 113-3 3 3 0 01-3 3zm0-4a1 1 0 101 1 1 1 0 00-1-1zm24 9a1 1 0 01-.71-.29L35.59 27H33v-2h3a1 1 0 01.71.29l5.29 5.3V26a1 1 0 011-1h2a1 1 0 001-1V7a1 1 0 00-1-1H24a1 1 0 00-1 1v6h-2V7a3 3 0 013-3h21a3 3 0 013 3v17a3 3 0 01-3 3h-1v6a1 1 0 01-.62.92.84.84 0 01-.38.08z'
            />
            <path
                className='SupportTechnical_svg__cls-1'
                d='M5 44a.84.84 0 01-.38-.08A1 1 0 014 43v-6H3a3 3 0 01-3-3V18a3 3 0 013-3h25a3 3 0 013 3v16a3 3 0 01-3 3H12.37l-6.66 6.71A1 1 0 015 44zM3 17a1 1 0 00-1 1v16a1 1 0 001 1h2a1 1 0 011 1v4.57l5.25-5.28A1 1 0 0112 35h16a1 1 0 001-1V18a1 1 0 00-1-1z'
            />
        </svg>
    );
};

BrandIconSupportTechnical.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['lg', 'xl', 'xxl']),
};
BrandIconSupportTechnical.defaultProps = {
    size: 'xl',
    focusable: false,
};
export default BrandIconSupportTechnical;
